
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "currentColor"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "g",
                      "children": [
                        {
                          "tag": "path",
                          "attrsMap": {
                            "fill": "currentColor",
                            "d": "M4.87 4.543l.528-2.997c.027-.157-.077-.306-.234-.334l-1.167-.205c-.157-.028-.306.077-.334.233l-.528 2.997c-.028.157.077.306.233.334l1.167.205c.157.028.307-.077.334-.233zm7.756-3.33l-1.167-.206c-.157-.028-.306.077-.334.233l-.528 2.997c-.028.157.077.306.234.334l1.167.205c.157.028.306-.077.334-.233l.528-2.997c.028-.157-.077-.306-.234-.334zm-.433 9.99h-1.185c-.16 0-.288.135-.288.302v3.19c0 .168.129.303.288.303h1.185c.16 0 .288-.135.288-.302v-3.191c0-.167-.129-.302-.288-.302zm-7.206 0H3.802c-.16 0-.289.135-.289.302v3.19c0 .168.13.303.289.303h1.185c.159 0 .288-.135.288-.302v-3.191c0-.167-.13-.302-.288-.302zm5.47-3.055c0-1.035-.642-1.92-1.55-2.278V3.74c0-.028-.003-.054-.01-.08h1.182c.18 0 .327-.129.327-.288l.24-1.217c0-.16-.147-.288-.328-.288H5.934c-.18 0-.327.129-.327.288l-.238 1.217c0 .16.146.288.327.288h1.422c-.008.026-.012.052-.012.08v2.13c-.907.359-1.55 1.243-1.55 2.278s.643 1.92 1.55 2.278v1.914H5.91c-.159 0-.288.129-.288.288v1.217c0 .16.129.288.288.288h4.196c.159 0 .288-.129.288-.288v-1.217c0-.16-.129-.288-.288-.288H8.908v-1.914c.907-.359 1.55-1.243 1.55-2.278zm-3.795 0c0-.396.171-.753.444-.999.041-.037.084-.07.13-.102l.014-.01.032-.022.02-.013.032-.018.023-.014.03-.016.026-.013.03-.014.027-.013.03-.012.03-.012.03-.01.03-.011.03-.01.032-.009.03-.007.034-.008.029-.006.036-.007.028-.004.039-.005.026-.004.044-.003.022-.001c.022-.002.045-.002.067-.002.022 0 .045 0 .067.002l.022.001.044.003.027.004.038.005c.01 0 .02.003.029.004l.035.007.03.006.033.008.03.008.032.009.03.01c.01.002.02.006.03.01l.03.01.03.012.03.012.027.013.03.014.025.013.031.016.023.014.032.018.02.013.032.021.015.01c.045.032.087.066.127.102.274.246.446.603.446 1 0 .396-.171.753-.444.999-.041.037-.085.071-.13.103l-.014.01-.033.022-.02.012-.031.019-.023.013-.03.016-.026.013-.03.014-.027.012c-.01.005-.02.01-.031.013l-.028.011-.031.012-.03.01-.03.01-.032.008-.03.008-.033.008-.03.006-.035.007-.029.004-.038.005-.027.004-.044.003-.022.001c-.022.002-.044.002-.067.002-.022 0-.045 0-.067-.002l-.022-.001-.044-.003-.026-.004-.04-.005c-.009 0-.018-.003-.027-.004l-.036-.007-.03-.006-.033-.008-.03-.007-.032-.01-.03-.009-.03-.01-.03-.011-.03-.012-.03-.012-.027-.013-.03-.014-.025-.013-.031-.016-.023-.014-.032-.018-.02-.013-.032-.021-.015-.01c-.045-.032-.088-.066-.129-.103-.273-.246-.444-.603-.444-.999z",
                            "transform": "translate(-257 -33) translate(240 27) translate(17 4) translate(0 2)"
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  